import { render, staticRenderFns } from "./branch-management.vue?vue&type=template&id=5b8ef12c&scoped=true&"
import script from "./branch-management.vue?vue&type=script&lang=js&"
export * from "./branch-management.vue?vue&type=script&lang=js&"
import style0 from "./branch-management.vue?vue&type=style&index=0&id=5b8ef12c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ef12c",
  null
  
)

export default component.exports